import { Component, Input, OnInit, HostListener, Output, EventEmitter } from '@angular/core';
import { NgbCalendar, NgbDate, NgbDateStruct } from '@ng-bootstrap/ng-bootstrap';
import { FieldsAgricolaService } from 'src/app/Services/agricola/fields.service';
import { GlobalFunction } from 'src/app/Services/public/globalFunction';

@Component({
  selector: 'app-cycle-form-modal',
  templateUrl: './cycle.html',
  styleUrls: ['./cycle.scss'],
})
export class CycleModalFormComponent implements OnInit {
  @Output('event') event = new EventEmitter();

  @Input('field') field;
  @Input('sector') sector;

	hoveredDate: NgbDate | null = null;

	fromDate: NgbDate;
	toDate: NgbDate | null = null;
  seasonID: any;

  agricolaSeasons: any[] = [];

  editCycle: boolean = true;

  displayMonths: number = 4;

  @HostListener('window:resize', ['$event'])
  onResize(event?) {
    const screenWidth = window.innerWidth;

    if (screenWidth >= 1200) {
      this.displayMonths = 4; // Pantalla grande
    } else if (screenWidth >= 992) {
      this.displayMonths = 3; // Pantalla mediana
    } else if (screenWidth >= 768) {
      this.displayMonths = 2; // Tablet
    } else {
      this.displayMonths = 1; // Celular
    }
  }

  constructor(
    public fieldsService: FieldsAgricolaService,
    public globalFunction: GlobalFunction,
    calendar: NgbCalendar
  ) {
    this.fromDate = calendar.getToday();
		this.toDate = calendar.getNext(calendar.getToday(), 'd', 60);
  }

  ngOnInit(): void {
    this.getSeasons();
    this.editCycle = this.sector.current_cycle?.id ? true : false;

    console.log(this.sector);
    

    if (this.editCycle) {
      this.seasonID = this.sector.current_cycle.id;
      this.fromDate = this.getDate(this.sector.current_cycle.start_date);
      this.toDate = this.getDate(this.sector.current_cycle.finish_date);
    }
  }

  ngAfterViewInit() {
    this.onResize();
  }

	onDateSelection(date: NgbDate) {
		if (!this.fromDate && !this.toDate) {
			this.fromDate = date;
		} else if (this.fromDate && !this.toDate && date.after(this.fromDate)) {
			this.toDate = date;
		} else {
			this.toDate = null;
			this.fromDate = date;
		}
	}

	isHovered(date: NgbDate) {
		return (
			this.fromDate && !this.toDate && this.hoveredDate && date.after(this.fromDate) && date.before(this.hoveredDate)
		);
	}

	isInside(date: NgbDate) {
		return this.toDate && date.after(this.fromDate) && date.before(this.toDate);
	}

	isRange(date: NgbDate) {
		return (
			date.equals(this.fromDate) ||
			(this.toDate && date.equals(this.toDate)) ||
			this.isInside(date) ||
			this.isHovered(date)
		);
	}

  getDate(date: any) {
    const newData = date.split('-');
    const data: NgbDate = new NgbDate(Number(newData[0]), Number(newData[1]), Number(newData[2]));
    return data
  }


  selectSeason(season: string) {
    this.seasonID = parseInt(season);
  }

  getSeasons() {
    let query = '?ordering=id';
    this.fieldsService.getSeasons(query).subscribe((res) => {
      this.agricolaSeasons = res;
    });
  }

  getNormalDate(date) {
    const data = `${date.year}-${date.month}-${date.day}`
    return data
  }

  setCycle() {
    const start_date = this.getNormalDate(this.fromDate)
    const finish_date = this.getNormalDate(this.toDate)

    let obj = {
      sector: this.sector.id,
      start_date: start_date,
      finish_date: finish_date,
      season: this.seasonID
    }
    
    if (this.editCycle) {
      this.fieldsService.editCycle(this.sector.current_cycle.id, obj).subscribe(res => {
        this.succesfullOperation('Editado correctamente');
      })
    } else {
      this.fieldsService.cycleRegister(obj).subscribe(res => {
        this.succesfullOperation('Creado correctamente');
      });
    }
  }

  succesfullOperation(text) {
    this.globalFunction.animation('success', text, 'Éxito');
    this.event.emit('success');
    this.globalFunction.Modal(``, `hide`, {});
  }
}
